var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_58498",
    "data-name": "Group 58498",
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.988,
    height: 82.458,
    viewBox: "0 0 101.988 82.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-camera",
    "data-name": "Icon feather-camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16621",
    "data-name": "Path 16621",
    d: "M103.488,77.8a9.217,9.217,0,0,1-9.272,9.162H10.772A9.217,9.217,0,0,1,1.5,77.8V27.405a9.217,9.217,0,0,1,9.272-9.162H29.315L38.586,4.5H66.4l9.272,13.743H94.216a9.217,9.217,0,0,1,9.272,9.162Z",
    transform: "translate(-1.5 -4.5)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16622",
    "data-name": "Path 16622",
    d: "M49.471,32.235A18.735,18.735,0,1,1,30.735,13.5,18.735,18.735,0,0,1,49.471,32.235Z",
    transform: "translate(20.258 13.492)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.757b725243232f963d5edeef18846b70.svg";
export { ForwardRef as ReactComponent };